import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * 
 * Automatically scrolls to the top of the page on every route change.
 * Does not affect anchor/hash navigation (#section links).
 * 
 * Usage: Place this component inside BrowserRouter in App.js
 */
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Don't scroll if navigating to an anchor/hash link
    if (hash) {
      // Allow browser to handle anchor scrolling naturally
      return;
    }

    // Scroll to top instantly on route change
    // Using both methods for maximum browser compatibility
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0; // For Safari
  }, [pathname, hash]);

  return null; // This component doesn't render anything
};

export default ScrollToTop;
